module.exports = __webpack_public_path__ + "static/assets/bd055c3853854218f060871e694b16f7.svg";